
import initialState from '../../../../store/initialState';
import * as types from '../services/strategiccapacityactionType';
const strategicCapacityReducer = (state = initialState.strategicCapacity, action) => {
  switch (action.type) {

    case types.FETCH_BLOCK_DEMAND_PLANNING_REPORTS_DD_REQUEST:
      return { ...state, isLoadingBlockDemandPlanningReportsDD: true, blockDemandPlanningReportsDDError: null };

    case types.FETCH_BLOCK_DEMAND_PLANNING_REPORTS_DD_SUCCESS:
      return { ...state, isLoadingBlockDemandPlanningReportsDD: false, blockDemandPlanningReportsDD: action.payload };

    case types.FETCH_BLOCK_DEMAND_PLANNING_REPORTS_DD_FAILURE:
      return { ...state, isLoadingBlockDemandPlanningReportsDD: false, blockDemandPlanningReportsDD: [], blockDemandPlanningReportsDDError: action.error };
    // strategicCapacityReducer.js
    case types.FETCH_ALL_REPORTS_PAGINATION_REQUEST:
      return { ...state, isAllReportsLoading: true };

    case types.FETCH_ALL_REPORTS_PAGINATION_SUCCESS:
      return { ...state, isAllReportsLoading: false, strategicCapacityReports: action.payload.data || [], totalReportsCount: action.payload.total || 0 };

    case types.FETCH_ALL_REPORTS_PAGINATION_FAILURE:
      return { ...state, isAllReportsLoading: false, strategicCapacityReports: [], totalReportsCount: 0 };
    case types.DELETE_STRATEGIC_CAPACITY_REPORT_REQUEST:
      return { ...state, isAllReportsLoading: true };

    case types.DELETE_STRATEGIC_CAPACITY_REPORT_SUCCESS:
      return { ...state, isAllReportsLoading: false };

    case types.DELETE_STRATEGIC_CAPACITY_REPORT_FAILURE:
      return { ...state, isAllReportsLoading: false };
    case types.EXPORT_CAPACITY_REPORT_REQUEST:
      return { ...state, isExportCapacityReportLoading: true, exportCapacityReportError: null };
    case types.EXPORT_CAPACITY_REPORT_SUCCESS:
      return { ...state, isExportCapacityReportLoading: false };
    case types.EXPORT_CAPACITY_REPORT_FAILURE:
      return { ...state, isExportCapacityReportLoading: false, exportCapacityReportError: action.error };
    case types.FETCH_BLOCK_CAPACITY_TABLE_REQUEST:
      return {
        ...state,
            isRadTransitionsLoading: true,

        radLoading: {
          ...state.radLoading,
          [action.payload.radTab]: true,
        },
      };

    case types.FETCH_BLOCK_CAPACITY_TABLE_SUCCESS:
      return {
        ...state,
            isRadTransitionsLoading: false,

        radLoading: {
          ...state.radLoading,
          [action.payload.radTab]: false,
        },
        radData: {
          ...state.radData,
          [action.payload.radTab]: action.payload.data || [],
        },
      };

    case types.FETCH_BLOCK_CAPACITY_TABLE_FAILURE:
      return {
        ...state,
            isRadTransitionsLoading: false,

        radLoading: {
          ...state.radLoading,
          [action.payload.radTab]: false,
        },
      };

    case types.FETCH_CAPACITY_TABLE_REPORT_REQUEST:
      return {
        ...state,
        isCapacityTableReportLoading: true,
      };


    case types.FETCH_CAPACITY_TABLE_REPORT_SUCCESS:
      return {
        ...state,
        isCapacityTableReportLoading: false,
        capacityTableReportData: action.payload.data || {},
     blockCapacityTableId: action.payload.blockCapacityTableId,

      };

    case types.FETCH_CAPACITY_TABLE_REPORT_FAILURE:
      return {
        ...state,
        isCapacityTableReportLoading: false,
        capacityTableReportData: [],
      };
    // strategicCapacityReducer.js
    case types.FETCH_REPORT_NOTE_REQUEST:
      return {
        ...state,
        isReportNoteLoading: true,
      };

    case types.FETCH_REPORT_NOTE_SUCCESS:
      return {
        ...state,
        isReportNoteLoading: false,
        reportNote: action.payload || "",
      };

    case types.FETCH_REPORT_NOTE_FAILURE:
      return {
        ...state,
        isReportNoteLoading: false,
        reportNote: "",
      };

    case types.UPDATE_REPORT_NOTE_REQUEST:
      return {
        ...state,
        isUpdateReportNoteLoading: true,
      };

    case types.UPDATE_REPORT_NOTE_SUCCESS:
      return {
        ...state,
        isUpdateReportNoteLoading: false,
      };

    case types.UPDATE_REPORT_NOTE_FAILURE:
      return {
        ...state,
        isUpdateReportNoteLoading: false,
      };
    // strategicCapacityReducer.js
    case types.FETCH_CAPACITY_DAILY_VIEW_REQUEST:
      return {
        ...state,
        isCapacityDailyViewLoading: true,
        capacityDailyViewError: null,
      };

    case types.FETCH_CAPACITY_DAILY_VIEW_SUCCESS:
      return {
        ...state,
        isCapacityDailyViewLoading: false,
        capacityDailyViewData: action.payload?.data || action.payload || [],
        totalDailyRecords: action.payload?.total || 0,
        capacityDailyLoaded: true,
      };

    case types.FETCH_CAPACITY_DAILY_VIEW_FAILURE:
      return {
        ...state,
        isCapacityDailyViewLoading: false,
        capacityDailyViewData: [],
        capacityDailyViewError: action.error,
      };
    case types.FETCH_CAPACITY_QUARTERLY_VIEW_REQUEST:
      return {
        ...state,
        isCapacityQuarterlyViewLoading: true,
      };

    case types.FETCH_CAPACITY_QUARTERLY_VIEW_SUCCESS:
      return {
        ...state,
        isCapacityQuarterlyViewLoading: false,
        capacityQuarterlyLoaded: true,
        capacityQuarterlyViewData: action.payload?.data || action.payload || [],
        totalQuarterlyRecords: action.payload?.total || 0,
      };

    case types.FETCH_CAPACITY_QUARTERLY_VIEW_FAILURE:
      return {
        ...state,
        isCapacityQuarterlyViewLoading: false,
        capacityQuarterlyViewData: [],
      };

    case types.FETCH_CAPACITY_FILTER_DD_REQUEST:
      return {
        ...state,
        isCapacityFilterDDLoading: true,
        capacityFilterDDError: null,
      };

    case types.FETCH_CAPACITY_FILTER_DD_SUCCESS:
      return {
        ...state,
        isCapacityFilterDDLoading: false,
        capacityFilterDD: action.payload?.values || {
          lstRPCE: [],
          lstWorklist: [],
          lstDay: [],
          lstDayType: [],
          lstCapacityType: [],
          lstWeekRotation: [],
          lstQuarter: [],
        },
      };

    case types.FETCH_CAPACITY_FILTER_DD_FAILURE:
      return {
        ...state,
        isCapacityFilterDDLoading: false,
        capacityFilterDDError: action.payload,
      };
    case types.FETCH_WORKLIST_BY_RPCE_REQUEST:
      return {
        ...state,
        isWorklistLoading: true,
        RPCEDATA: [],
      };

    case types.FETCH_WORKLIST_BY_RPCE_SUCCESS:
      return {
        ...state,
        isWorklistLoading: false,
        RPCEDATA: action.payload, // ✅ already array
      };

    case types.FETCH_WORKLIST_BY_RPCE_FAILURE:
      return {
        ...state,
        isWorklistLoading: false,
        RPCEDATA: [],
      };
    case types.RESET_STRATEGIC_CAPACITY_STATE:
      return {
        ...state,
        radData: {
          Active: [],
          Pending: [],
          Offboarding: [],
        },
        radLoading: {
          Active: false,
          Pending: false,
          Offboarding: false,
        },
        capacityTableActionSuccess: false, // 🔑 KEY
    blockCapacityTableId: null,

        capacityDailyViewData: [],
        capacityDailyViewTotal: 0,
        isCapacityDailyViewLoading: false,
        capacityDailyLoaded: false,
        capacityQuarterlyLoaded: false,
        RPCEDATA: [],
        isWorklistLoading: false,
      };
    case types.FETCH_ONBOARDING_SITE_LEGEND_REQUEST:
      return { ...state, isSiteLegendLoading: true, siteLegend: null };

    case types.FETCH_ONBOARDING_SITE_LEGEND_SUCCESS:
      return { ...state, isSiteLegendLoading: false, siteLegend: action.payload };

    case types.FETCH_ONBOARDING_SITE_LEGEND_FAILURE:
      return { ...state, isSiteLegendLoading: false, siteLegendError: action.payload };
    case types.DRAFT_CAPACITY_TABLE_REQUEST:
    case types.PUBLISH_CAPACITY_TABLE_REQUEST:
      return {
        ...state,
        isCapacityTableActionLoading: true,

      };

    case types.DRAFT_CAPACITY_TABLE_SUCCESS:
    case types.PUBLISH_CAPACITY_TABLE_SUCCESS:
      return {
        ...state,
        isCapacityTableActionLoading: false,
        capacityTableActionSuccess: true, // 🔑 KEY

      };

    case types.DRAFT_CAPACITY_TABLE_FAILURE:
    case types.PUBLISH_CAPACITY_TABLE_FAILURE:
      return {
        ...state,
        isCapacityTableActionLoading: false,
      };

    // strategiccapacity cascading WeekQuarterByMonthYear
    case types.FETCH_WEEK_QUARTER_BY_MONTH_YEAR_REQUEST:
      return {
        ...state,
        isWeekQuarterLoading: true,
        weekQuarterError: null,
      };

    case types.FETCH_WEEK_QUARTER_BY_MONTH_YEAR_SUCCESS:
      return {
        ...state,
        isWeekQuarterLoading: false,
        weekRotationOptions: action.payload.weeks || [],
        quarterOptions: action.payload.quarters || [],
      };

    case types.FETCH_WEEK_QUARTER_BY_MONTH_YEAR_FAILURE:
      return {
        ...state,
        isWeekQuarterLoading: false,
        weekRotationOptions: [],
        quarterOptions: [],
        weekQuarterError: action.error,
      };



    default:
      return state;
  }
};
export default strategicCapacityReducer;